import { C } from '@parsina/framework/tokens';

/**
 * The doctor wizard's closing card (`StepSuccess`): a 72px green disc with a
 * check, a 19/800 line, a 12px explanation. The doctor's ends in «ورود به پنل»;
 * the clinic's enters on its own once the new grants are adopted, so it shows
 * the boot card's three dots where that button would be.
 */
export default function OnboardingSuccess({ title, body, children, testId = 'onboarding-success' }) {
  return (
    <div
      data-testid={testId}
      role="status"
      aria-live="polite"
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <div
        aria-hidden="true"
        style={{
          width: 72, height: 72, borderRadius: '50%',
          background: '#E6F5EF', border: '6px solid #D1FAE5',
          display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16,
        }}
      >
        <svg viewBox="0 0 24 24" fill={C.green} width="36" height="36"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
      </div>
      <div style={{ fontSize: 19, fontWeight: 800, color: C.textPrimary, marginBottom: 6, textAlign: 'center' }}>
        {title}
      </div>
      {body ? (
        <div style={{ fontSize: 12, color: C.textSecondary, marginBottom: 24, textAlign: 'center', lineHeight: 1.8, maxWidth: 320 }}>
          {body}
        </div>
      ) : null}
      {children || (
        <div aria-hidden="true" style={{ display: 'flex', justifyContent: 'center', gap: 10 }}>
          {[0, 0.18, 0.36].map((delay) => (
            <div key={delay} className="boot-dot" style={{ width: 10, height: 10, borderRadius: '50%', background: C.navy, animationDelay: `${delay}s` }} />
          ))}
        </div>
      )}
    </div>
  );
}
